import { RootState } from "@/store/store";
import { commitmentsDetailsDrawerDetailsSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerDetailsSelector";

export const azureReservationSelectedCoverageDataRegionSelector = (
  state: RootState,
): string | undefined => {
  const { region } = commitmentsDetailsDrawerDetailsSelector(state);

  return region;
};
